module.exports = __webpack_public_path__ + "media/Speaker_med.1d241f9d.mp4";